import { Box, Stack } from '@mui/material';

import { Icon } from '@/components/shared/icon';

export type TagStatus = 'active' | 'inactive' | 'pending' | 'error';

export const StatusTag = ({
  status,
  label,
  icon,
}: {
  status: TagStatus;
  label: string;
  icon: string;
}) => {
  const backgroundColor =
    status === 'active'
      ? 'var(--mui-palette-success-opacity)'
      : status === 'inactive'
        ? 'var(--mui-palette-background-default)'
        : status === 'pending'
          ? 'var(--mui-palette-custom-ORANGE-07)'
          : 'var(--mui-palette-background-default)';
  const color =
    status === 'active'
      ? 'var(--mui-palette-success-main)'
      : status === 'inactive'
        ? 'var(--mui-palette-custom-GREY-01)'
        : status === 'pending'
          ? 'var(--mui-palette-custom-ORANGE-01)'
          : 'var(--mui-palette-custom-GREY-01)';

  return (
    <Box
      sx={{
        borderRadius: '4px',
        height: '32px',
        width: 'auto',
        // eslint-disable-next-line @eon/no-manual-typography
        fontWeight: 500,
        backgroundColor,
      }}
    >
      <Stack
        direction='row'
        sx={{
          alignItems: 'center',
          justifyContent: 'space-evenly',
        }}
      >
        <Box sx={{ paddingLeft: '4px' }}>
          <Icon color={color} iconClass={icon} />
        </Box>
        <Box
          sx={{
            // eslint-disable-next-line @eon/no-manual-typography
            fontSize: '12px',
            height: '32px',
            paddingRight: '12px',
            // eslint-disable-next-line @eon/no-manual-typography
            fontWeight: 500,
            lineHeight: '32px',
            color,
          }}
        >
          {label}
        </Box>
      </Stack>
    </Box>
  );
};
